import type { AuthObject } from '@white-label-types/auth';
import { Auth0Client } from '@auth0/auth0-spa-js';
import { datadogRum } from '@datadog/browser-rum';

export const refreshUserWrapper = async (
  auth0Client: Auth0Client | null,
  authInstance: AuthObject
) => {
  try {
    const user = await auth0Client?.getUser();
    const isAuthenticated = await auth0Client?.isAuthenticated();
    authInstance.user =  user || null
    authInstance.isAuthenticated =  isAuthenticated || false;
  } catch(error) {
    const errorContext = {
      file: 'white-label-plugin > auth.ts > refreshUserWrapper()',
      domain: authInstance.domain || '',
      user: authInstance.user || '',
      isAuthenticated: authInstance.isAuthenticated || '',
    }
    datadogRum.addError(
      new Error('Auth fetchUser:', { cause: error }),
      errorContext
    );
  }
};
